import { TopLevelSpec as VegaLiteSpec } from 'vega-lite';
import { TimeUnit } from 'vega-lite/build/src/timeunit';
import { liteBaseConfig } from '../vegaShared';

export interface IHeatmapOptions {
  data: any[];
  xField: string;
  yField: string;
  zField?: string;
  timeUnit: TimeUnit;
  colorScheme?: string;
  colorReverse?: boolean;
  xAxisTitle?: string;
  yAxisTitle?: string;
  xLabels?: boolean;
  yLabels?: boolean;
  width?: number | 'container';
  height?: number | 'container';
  circular?: boolean;
}

export const genHeatmapSpec = (options: IHeatmapOptions): VegaLiteSpec => {
  const config = {
    ...liteBaseConfig(),
    view: { fill: '#F9FAFF', stroke: 'white' },
  };
  const baseSpec: VegaLiteSpec = {
    $schema: 'https://vega.github.io/schema/vega-lite/v4.json',
    autosize: 'fit',
    width: options.width || 'container',
    height: options.height || undefined, // autoheight based on number of rows if height not specified
    mark: { type: options.circular ? 'circle' : 'rect', tooltip: true, cornerRadius: 2, stroke: 'white', strokeWidth: 2 },
    config,
    encoding: {
      x: {
        field: options.xField,
        timeUnit: { unit: options.timeUnit },
        type: 'temporal',
        axis: {
          title: options.xAxisTitle || null,
        },
      },
      y: {
        field: options.yField,
        type: 'nominal',
        sort: { op: 'sum', order: 'descending', field: options.zField },
        axis: {
          title: options.yAxisTitle || null,
          titlePadding: 20,
          labelPadding: options.circular ? 16 : 5,
          labelFontWeight: 800,
          labelFontSize: 11,
        },
      },
      color: {
        scale: { scheme: options.colorScheme || 'blues', reverse: options.colorReverse || false, range: ['white', '#3c5ccf'] },
        legend: null,
        ...(!options.zField && { aggregate: 'count' }),
        ...(options.zField && { field: options.zField, type: 'quantitative' }),
      },
      size: !options.circular ? undefined : { aggregate: 'count', legend: null },
    },
    data: { values: options.data },
  };
  return baseSpec;
};
